import { Routes } from '@angular/router';
import { CountryDetectGuard } from './reusables/services/country-detect.guard';

// TODO titles.
export const routes: Routes = [
    {
        path: 'takata',
        loadComponent: () => import('./pages/main.component').then(c => c.MainComponent),
        canActivate: [CountryDetectGuard]
    },
    {
        path: 'takata/:countryCode/:langCode',
        loadComponent: () => import('./pages/main.component').then(c => c.MainComponent),
        canActivate: [CountryDetectGuard]
    },
    {
        path: 'takata/:countryCode/:langCode/:brandCode',
        loadComponent: () => import('./pages/brand-recall.component').then(c => c.BrandRecallComponent)
    },
    { path: '', redirectTo: 'takata/fr/fr', pathMatch: 'full' },
    { path: '**', redirectTo: 'takata/fr/fr', pathMatch: 'full' },
];
